import * as React from "react";
const LoadingSplashIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={914.149}
    height={214.181}
    viewBox="0 0 914.149 214.181"
    {...props}
  >
    <g id="OBJECTS" transform="translate(-0.01 0.02)" opacity={0.39}>
      <g
        id="Raggruppa_208"
        data-name="Raggruppa 208"
        transform="translate(0.01 -0.02)"
      >
        <g id="Raggruppa_206" data-name="Raggruppa 206">
          <g
            id="Raggruppa_204"
            data-name="Raggruppa 204"
            transform="translate(516.311)"
          >
            <path
              id="Tracciato_41"
              data-name="Tracciato 41"
              d="M137.9.325H35.641A5.741,5.741,0,0,0,29.95,6.016a5.741,5.741,0,0,0,5.691,5.691H137.9A4.137,4.137,0,0,0,141.7,9.637a4.419,4.419,0,0,0,.517-3.794,4.419,4.419,0,0,0-.517-3.794A4.739,4.739,0,0,0,137.9-.02Z"
              transform="translate(-29.95 0.02)"
              fill="#35a8e0"
            />
            <path
              id="Tracciato_42"
              data-name="Tracciato 42"
              d="M136.351,8.18H35.641a5.691,5.691,0,1,0,0,11.382h100.71a5.691,5.691,0,1,0,0-11.382Z"
              transform="translate(-29.95 133.228)"
              fill="#35a8e0"
            />
            <path
              id="Tracciato_43"
              data-name="Tracciato 43"
              d="M141.7,6.159A4.739,4.739,0,0,0,137.9,4.09H35.641A5.741,5.741,0,0,0,29.95,9.781a5.741,5.741,0,0,0,5.691,5.691H137.9A4.137,4.137,0,0,0,141.7,13.4a4.419,4.419,0,0,0,.517-3.794,4.419,4.419,0,0,0-.517-3.794Z"
              transform="translate(-29.95 66.786)"
              fill="#35a8e0"
            />
            <path
              id="Tracciato_44"
              data-name="Tracciato 44"
              d="M44,11.716H146.263a4.137,4.137,0,0,0,3.794-2.069,4.419,4.419,0,0,0,.517-3.794,4.419,4.419,0,0,0-.517-3.794A4.739,4.739,0,0,0,146.263-.01H44A5.741,5.741,0,0,0,38.31,5.681,5.741,5.741,0,0,0,44,11.372Z"
              transform="translate(105.857 0.182)"
              fill="#35a8e0"
            />
            <path
              id="Tracciato_45"
              data-name="Tracciato 45"
              d="M150.067,6.159a4.739,4.739,0,0,0-3.794-2.069H44.011A5.741,5.741,0,0,0,38.32,9.781a5.741,5.741,0,0,0,5.691,5.691H146.273a4.137,4.137,0,0,0,3.794-2.069,4.419,4.419,0,0,0,.517-3.794,4.419,4.419,0,0,0-.517-3.794Z"
              transform="translate(106.019 66.786)"
              fill="#35a8e0"
            />
            <path
              id="Tracciato_46"
              data-name="Tracciato 46"
              d="M144.721,8.18H44.011a5.691,5.691,0,1,0,0,11.382h100.71a5.691,5.691,0,0,0,0-11.382Z"
              transform="translate(106.019 133.228)"
              fill="#35a8e0"
            />
          </g>
          <g
            id="Raggruppa_205"
            data-name="Raggruppa 205"
            transform="translate(0 3.104)"
          >
            <path
              id="Tracciato_47"
              data-name="Tracciato 47"
              d="M2.942.16A3.022,3.022,0,0,0,.01,3.092V144.154a2.907,2.907,0,0,0,2.932,2.932,3.022,3.022,0,0,0,2.932-2.932V3.092A3.022,3.022,0,0,0,2.942.16Z"
              transform="translate(-0.01 -0.16)"
              fill="#2d2e82"
            />
            <path
              id="Tracciato_48"
              data-name="Tracciato 48"
              d="M106.021.16h0a3.022,3.022,0,0,0-2.932,2.932V135.015L7.726,1.54A6.088,6.088,0,0,0,5.312.332,3.022,3.022,0,0,0,2.38,3.264V144.327a3.022,3.022,0,0,0,2.932,2.932,3.022,3.022,0,0,0,2.932-2.932V12.231l95.364,133.648a6.088,6.088,0,0,0,2.414,1.207,3.022,3.022,0,0,0,2.932-2.932V3.092A3.022,3.022,0,0,0,106.021.16Z"
              transform="translate(38.49 -0.16)"
              fill="#2d2e82"
            />
            <path
              id="Tracciato_49"
              data-name="Tracciato 49"
              d="M119.417,81.728c-11.554-4.829-26.73-7.76-41.388-10.519h-.69C63.372,68.45,47.506,65.346,36.47,60.517c-5.691-2.414-9.83-5.173-12.589-8.278A16.278,16.278,0,0,1,19.4,40.685c0-7.933,5.518-16.555,14.831-22.936C41.988,12.4,56.129,6.023,78.72,6.023s42.25,6.381,53.459,17.417a3.182,3.182,0,0,0,2.069.862,3.022,3.022,0,0,0,2.932-2.932,3.182,3.182,0,0,0-.862-2.069C123.9,7.23,102.862.16,78.72.16s-39.146,6.9-47.768,12.761c-11.037,7.588-17.417,17.59-17.417,27.764A23.487,23.487,0,0,0,19.4,56.206c3.449,3.794,8.278,7.07,14.658,9.83,11.727,5,27.247,7.933,42.077,10.864,14.831,2.759,30.006,5.691,41.043,10.347a39.715,39.715,0,0,1,12.761,8.105,15.484,15.484,0,0,1,4.484,11.209c0,12.416-9.485,20.521-17.417,25.005-10.692,6.208-25.35,9.657-40.18,9.657-23.97,0-45.871-6.553-61.737-18.28a3.642,3.642,0,0,0-1.724-.69,3.022,3.022,0,0,0-2.932,2.932,3.294,3.294,0,0,0,1.207,2.414c16.9,12.589,40.18,19.487,65.358,19.487,15.693,0,31.386-3.794,42.94-10.519,13.106-7.588,20.349-18.28,20.349-30.006a21.674,21.674,0,0,0-6.036-15.175c-3.449-3.794-8.278-6.9-14.658-9.657Z"
              transform="translate(169.261 -0.16)"
              fill="#2d2e82"
            />
            <path
              id="Tracciato_50"
              data-name="Tracciato 50"
              d="M22.772.16A3.022,3.022,0,0,0,19.84,3.092V144.154a2.932,2.932,0,0,0,5.863,0V3.092A3.022,3.022,0,0,0,22.772.16Z"
              transform="translate(322.125 -0.16)"
              fill="#2d2e82"
            />
            <path
              id="Tracciato_51"
              data-name="Tracciato 51"
              d="M45.148.16H24.972A3.022,3.022,0,0,0,22.04,3.092a3.022,3.022,0,0,0,2.932,2.932H45.148c27.592,0,48.113,6.553,60.874,19.314,11.209,11.209,16.727,27.419,16.727,48.286s-5.691,37.249-16.727,48.286C93.261,134.67,72.74,141.223,45.148,141.223H24.972a2.932,2.932,0,0,0,0,5.863H45.148c29.144,0,51.045-7.07,65.013-21.039C122.4,113.8,128.613,96.214,128.613,73.623S122.4,33.443,110.161,21.2C96.193,7.23,74.292.16,45.148.16Z"
              transform="translate(357.864 -0.16)"
              fill="#2d2e82"
            />
            <path
              id="Tracciato_52"
              data-name="Tracciato 52"
              d="M134.271,7.92C122.2,1.195,107.714.16,100.126.16H49.772A3.022,3.022,0,0,0,46.84,3.092a3.022,3.022,0,0,0,2.932,2.932h50.355c7.07,0,20.349.862,31.386,6.9,10.864,6.036,16.21,15.175,16.21,27.764s-5.346,21.9-16.21,27.937c-8.105,4.484-19.487,7.07-31.386,7.07H49.772a3.022,3.022,0,0,0-2.932,2.932v65.53a2.932,2.932,0,1,0,5.863,0v-62.6h47.423c7.588,0,22.073-1.035,34.145-7.76,8.795-4.829,19.142-14.486,19.142-32.938S143.066,12.749,134.271,7.92Z"
              transform="translate(760.736 -0.16)"
              fill="#2d2e82"
            />
          </g>
        </g>
        <g
          id="Raggruppa_207"
          data-name="Raggruppa 207"
          transform="translate(0 189.176)"
        >
          <path
            id="Tracciato_53"
            data-name="Tracciato 53"
            d="M20.014,11.142s-.69,0-.862.172c-.172,0-.345.345-.517.69L10.7,30.8,2.942,12S2.252,10.97,1.39,10.97c-.517,0-.862,0-1.035.345C.01,11.487.01,11.832.01,12.35a2.187,2.187,0,0,0,.172,1.035l9.14,20.866s.862,1.035,1.38,1.035a1.311,1.311,0,0,0,1.38-1.035l9.14-21.039a3.508,3.508,0,0,0,.172-.862,1.267,1.267,0,0,0-.345-1.035,2.451,2.451,0,0,0-1.035-.345Z"
            transform="translate(-0.01 -10.625)"
            fill="#2d2e82"
          />
          <path
            id="Tracciato_54"
            data-name="Tracciato 54"
            d="M13.077,25.283a7.383,7.383,0,0,0,3.1-2.587,7.558,7.558,0,0,0,1.035-3.966,7.558,7.558,0,0,0-1.035-3.966A7.074,7.074,0,0,0,13.422,12,8.193,8.193,0,0,0,9.283,10.97H3.764a1.619,1.619,0,0,0-1.207.517,1.566,1.566,0,0,0-.517,1.207V33.733a1.618,1.618,0,0,0,.517,1.207,1.565,1.565,0,0,0,1.207.517c.517,0,.862,0,1.207-.517a1.566,1.566,0,0,0,.517-1.207v-7.76H9.973L15.319,34.6a3.3,3.3,0,0,0,1.38.69,1.455,1.455,0,0,0,1.207-.345,1.724,1.724,0,0,0,0-2.069l-4.829-7.588ZM9.283,23.041H5.317V14.074H9.283a4.815,4.815,0,0,1,3.449,1.38,4.711,4.711,0,0,1,1.38,3.277,4.318,4.318,0,0,1-1.38,3.1,4.7,4.7,0,0,1-3.449,1.207Z"
            transform="translate(32.967 -10.625)"
            fill="#2d2e82"
          />
          <path
            id="Tracciato_55"
            data-name="Tracciato 55"
            d="M20.888,13.039s.517,0,.69-.345a.9.9,0,0,0,.345-.69c0-.345,0-.517-.345-.69a.9.9,0,0,0-.69-.345h-15s-.517,0-.69.345A.9.9,0,0,0,4.85,12V34.423s0,.517.345.69.345.345.69.345h15s.517,0,.69-.345a.9.9,0,0,0,.345-.69.688.688,0,0,0-.345-.69.9.9,0,0,0-.69-.345H6.919V24.076H17.266s.517,0,.69-.345a.9.9,0,0,0,.345-.69c0-.345,0-.517-.345-.69a.9.9,0,0,0-.69-.345H6.919V12.694H20.888Z"
            transform="translate(78.615 -10.625)"
            fill="#2d2e82"
          />
          <path
            id="Tracciato_56"
            data-name="Tracciato 56"
            d="M17.434,22.869,24.85,12.522V12a.688.688,0,0,0-.345-.69.9.9,0,0,0-.69-.345c-.345,0-.517,0-.69.345L15.882,21.489,8.639,11.315a2.528,2.528,0,0,0-.69-.345,1.037,1.037,0,0,0-.69.172,1.737,1.737,0,0,0-.172.517,1.037,1.037,0,0,0,.172.69l7.415,10.174L6.742,33.561a1.784,1.784,0,0,0-.172.69.688.688,0,0,0,.345.69c.172,0,.345.172.69.172s.517,0,.69-.345L16.227,23.9,24.16,34.768s0,.172.345.172h.345c.345,0,.517,0,.69-.345a1.037,1.037,0,0,0,.172-.69c0-.345,0-.517-.172-.69L17.607,22.179Z"
            transform="translate(106.556 -10.625)"
            fill="#2d2e82"
          />
          <path
            id="Tracciato_57"
            data-name="Tracciato 57"
            d="M19.719,12a8.011,8.011,0,0,0-3.966-1.035H9.545s-.517,0-.69.172a.9.9,0,0,0-.345.69V34.251s0,.517.345.69.345.345.69.345.517,0,.69-.345c0-.172.172-.345.172-.69V26.49h5.346a7.558,7.558,0,0,0,3.966-1.035A7.074,7.074,0,0,0,22.478,22.7a8.119,8.119,0,0,0,0-7.933A7.074,7.074,0,0,0,19.719,12Zm1.207,9.83A5.944,5.944,0,0,1,18.857,23.9a5.906,5.906,0,0,1-3.1.69H10.407v-11.9h5.346a6.314,6.314,0,0,1,3.1.69,5.944,5.944,0,0,1,2.069,2.069,5.906,5.906,0,0,1,.69,3.1,5.906,5.906,0,0,1-.69,3.1Z"
            transform="translate(138.071 -10.625)"
            fill="#2d2e82"
          />
          <path
            id="Tracciato_58"
            data-name="Tracciato 58"
            d="M26.208,13.039s.517,0,.69-.345a.9.9,0,0,0,.345-.69c0-.345,0-.517-.345-.69a.9.9,0,0,0-.69-.345h-15s-.517,0-.69.345a.9.9,0,0,0-.345.69V34.423s0,.517.345.69a.9.9,0,0,0,.69.345h15s.517,0,.69-.345a.9.9,0,0,0,.345-.69.688.688,0,0,0-.345-.69.9.9,0,0,0-.69-.345H12.239V24.076H22.586s.517,0,.69-.345.345-.345.345-.69,0-.517-.345-.69a.9.9,0,0,0-.69-.345H12.239V12.694H26.208Z"
            transform="translate(165.038 -10.625)"
            fill="#2d2e82"
          />
          <path
            id="Tracciato_59"
            data-name="Tracciato 59"
            d="M21.465,25.131a7.506,7.506,0,0,0,3.794-2.587,7.546,7.546,0,0,0,1.38-4.311A6.953,6.953,0,0,0,25.6,14.439a6.657,6.657,0,0,0-2.759-2.587,7.86,7.86,0,0,0-3.966-.862H13.015s-.517,0-.69.172a.9.9,0,0,0-.345.69V34.271s0,.517.345.69.345.345.69.345.517,0,.69-.345c0-.172.172-.345.172-.69V25.648H19.4l5.691,9.14s.172.345.345.345h.517c.345,0,.517,0,.69-.172s.345-.345.345-.517a1.3,1.3,0,0,0-.172-.69L21.465,25.3Zm-2.587-1.552h-5V12.714h5a6.314,6.314,0,0,1,3.1.69,5.482,5.482,0,0,1,2.069,1.9,5.06,5.06,0,0,1,.69,2.759,5.06,5.06,0,0,1-.69,2.759,4.388,4.388,0,0,1-2.069,1.9,5.906,5.906,0,0,1-3.1.69Z"
            transform="translate(194.441 -10.3)"
            fill="#2d2e82"
          />
          <path
            id="Tracciato_60"
            data-name="Tracciato 60"
            d="M14.685,10.98s-.517,0-.69.345a.9.9,0,0,0-.345.69V34.433s0,.517.345.69a.9.9,0,0,0,.69.345c.345,0,.517,0,.69-.345a.9.9,0,0,0,.345-.69V12.015s0-.517-.345-.69A.9.9,0,0,0,14.685,10.98Z"
            transform="translate(221.57 -10.463)"
            fill="#2d2e82"
          />
          <path
            id="Tracciato_61"
            data-name="Tracciato 61"
            d="M30.728,13.039s.517,0,.69-.345a.9.9,0,0,0,.345-.69c0-.345,0-.517-.345-.69a.9.9,0,0,0-.69-.345h-15s-.517,0-.69.345a.9.9,0,0,0-.345.69V34.423s0,.517.345.69a.9.9,0,0,0,.69.345h15s.517,0,.69-.345.345-.345.345-.69a.688.688,0,0,0-.345-.69c-.345-.172-.345-.345-.69-.345H16.759V24.076H27.106s.517,0,.69-.345a.9.9,0,0,0,.345-.69c0-.345,0-.517-.345-.69a.9.9,0,0,0-.69-.345H16.759V12.694H30.728Z"
            transform="translate(238.464 -10.625)"
            fill="#2d2e82"
          />
          <path
            id="Tracciato_62"
            data-name="Tracciato 62"
            d="M34.962,10.98s-.517,0-.69.345a.9.9,0,0,0-.345.69V31.846L18.235,11.325a1.2,1.2,0,0,0-.69-.345c-.345,0-.517,0-.69.345a.9.9,0,0,0-.345.69V34.433s0,.517.345.69.345.345.69.345.517,0,.69-.345.345-.345.345-.69V14.6L34.445,35.123a1.2,1.2,0,0,0,.69.345.689.689,0,0,0,.69-.345c.172-.345.345-.345.345-.69V12.015s0-.517-.345-.69a.9.9,0,0,0-.69-.345Z"
            transform="translate(268.03 -10.463)"
            fill="#2d2e82"
          />
          <path
            id="Tracciato_63"
            data-name="Tracciato 63"
            d="M25.56,14.4a8.981,8.981,0,0,1,5.173-1.38,9,9,0,0,1,6.208,2.069c.345.172.517.345.69.345.345,0,.517,0,.69-.345,0-.172.172-.345.172-.69s0-.517-.345-.69a11.454,11.454,0,0,0-7.588-2.759,10.322,10.322,0,0,0-6.036,1.724,13.921,13.921,0,0,0-4.484,4.484,12.755,12.755,0,0,0-1.552,6.208,11.258,11.258,0,0,0,1.724,6.208A11.219,11.219,0,0,0,24.7,34.058a11.1,11.1,0,0,0,6.036,1.724c3.277,0,5.863-.862,7.588-2.587a1.784,1.784,0,0,0,.172-.69c0-.345,0-.517-.345-.69a.9.9,0,0,0-.69-.345h-.517a9.627,9.627,0,0,1-6.381,2.242,10.535,10.535,0,0,1-5.173-1.38,11.4,11.4,0,0,1-3.794-3.794,11.2,11.2,0,0,1-1.38-5.346,10.535,10.535,0,0,1,1.38-5.173,11.888,11.888,0,0,1,3.794-3.966Z"
            transform="translate(300.195 -10.95)"
            fill="#2d2e82"
          />
          <path
            id="Tracciato_64"
            data-name="Tracciato 64"
            d="M36.558,33.713H22.589V24.4H32.936s.517,0,.69-.345a.9.9,0,0,0,.345-.69c0-.345,0-.517-.345-.69a.9.9,0,0,0-.69-.345H22.589V13.019H36.558s.517,0,.69-.345a.9.9,0,0,0,.345-.69c0-.345,0-.517-.345-.69a.9.9,0,0,0-.69-.345h-15s-.517,0-.69.345a.9.9,0,0,0-.345.69V34.4s0,.517.345.69.345.345.69.345h15s.517,0,.69-.345a.9.9,0,0,0,.345-.69.688.688,0,0,0-.345-.69.9.9,0,0,0-.69-.345Z"
            transform="translate(333.172 -10.95)"
            fill="#2d2e82"
          />
        </g>
      </g>
    </g>
  </svg>
);
export default LoadingSplashIcon;
